import { useMutation } from '@tanstack/react-query';
import {
  UserWalletTransactionService,
  BaseResponseEntity,
} from 'services/openapi';

export type BaseResponseDto = {
  transactionCode: string;
};

export const useRetrySendReferralPointMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<BaseResponseEntity, Error, BaseResponseDto>({
      mutationFn: (variables: BaseResponseDto) => {
        return UserWalletTransactionService.transactionControllerRetrySendReferralPOint(
          variables.transactionCode,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
